export const deptCookieName = 'departmentIds';
